/**
 * Wijn.com 4-11-2026: snelkeuze voor de prijs in de filterlade (snippets/wijncom-prijspillen.liquid).
 *
 * Een pil vult de twee prijsvelden van het thema en stuurt een change-event, zodat het thema
 * filtert zoals bij zelf intikken (price-facet-component/updatePriceFilterAndResults). Nog een
 * klik op de gekozen pil maakt de velden leeg. De grenzen (data-min/data-max) gaan eerst mee,
 * anders zet het thema bij een lagere klas de hoogste prijs terug op de vorige ondergrens.
 */

document.addEventListener('click', (event) => {
  const doel = /** @type {Element} */ (event.target);
  const pil = doel.closest?.('.wc-prijspil');
  if (!(pil instanceof HTMLElement)) return;

  const facet = pil.closest('price-facet-component');
  const minVeld = facet?.querySelector('input[ref="minInput"]');
  const maxVeld = facet?.querySelector('input[ref="maxInput"]');
  if (!(minVeld instanceof HTMLInputElement) || !(maxVeld instanceof HTMLInputElement)) return;

  event.preventDefault();
  const weg = pil.classList.contains('is-actief');
  const van = weg ? '' : (pil.dataset.wcVan ?? '');
  const tot = weg ? '' : (pil.dataset.wcTot ?? '');

  minVeld.value = van;
  maxVeld.value = tot;
  minVeld.setAttribute('data-max', tot || (maxVeld.getAttribute('data-max') ?? ''));
  maxVeld.setAttribute('data-min', van || '0');

  for (const andere of facet.querySelectorAll('.wc-prijspil')) {
    const aan = andere === pil && !weg;
    andere.classList.toggle('is-actief', aan);
    andere.setAttribute('aria-pressed', String(aan));
  }

  maxVeld.dispatchEvent(new Event('change', { bubbles: true }));
});
